import { Button, Modal } from 'antd';
import {
	CloseOutlined,
	PlusSquareOutlined,
	CheckCircleOutlined,
	SafetyCertificateOutlined,
} from '@ant-design/icons';
import { useInstallPWA } from '../../hooks/useInstallPWA';

import cadiraIcon from '../../assets/icons/cadira-icon.webp';
import { ReactComponent as ShareAppleIcon } from '../../assets/icons/share-apple.svg';

import './styles.scss';

const InstallPWA = () => {
	const { showInstall, install, showGuide, closeGuide, dismiss } =
		useInstallPWA();

	if (!showInstall) return null;

	return (
		<>
			<div className="install-pwa-sheet">
				<button
					type="button"
					className="install-pwa-sheet__close"
					onClick={dismiss}
					aria-label="Tutup"
				>
					<CloseOutlined />
				</button>
				<div className="install-pwa-sheet__content">
					<img
						src={cadiraIcon}
						alt="Cadira"
						className="install-pwa-sheet__icon"
					/>
					<div className="install-pwa-sheet__info">
						<p className="install-pwa-sheet__title">Cadira</p>
						<p className="install-pwa-sheet__desc">
							Akses lebih cepat dari home screen
						</p>
					</div>
				</div>
				<Button
					type="primary"
					block
					size="large"
					className="install-pwa-sheet__btn"
					onClick={install}
				>
					Install App
				</Button>
			</div>

			<Modal
				title={null}
				open={showGuide}
				onCancel={closeGuide}
				footer={null}
				centered
				className="install-guide-modal"
			>
				<div className="install-guide">
					<div className="install-guide__header">
						<img
							src={cadiraIcon}
							alt="Cadira"
							className="install-guide__logo"
						/>
						<p className="install-guide__title">Install Cadira</p>
						<p className="install-guide__subtitle">
							Ikuti langkah berikut di Safari
						</p>
					</div>

					<div className="install-guide__steps">
						<div className="install-guide__step">
							<div className="install-guide__step-number">1</div>
							<div className="install-guide__step-icon">
								<ShareAppleIcon width={22} height={22} fill="currentColor" />
							</div>
							<div className="install-guide__step-text">
								<p className="install-guide__step-title">Tekan Share</p>
								<p className="install-guide__step-desc">
									Ikon kotak dengan panah ke atas di bagian bawah layar
								</p>
							</div>
						</div>
						<div className="install-guide__step">
							<div className="install-guide__step-number">2</div>
							<div className="install-guide__step-icon">
								<PlusSquareOutlined />
							</div>
							<div className="install-guide__step-text">
								<p className="install-guide__step-title">Add to Home Screen</p>
								<p className="install-guide__step-desc">
									Scroll ke bawah dan pilih opsi ini
								</p>
							</div>
						</div>
						<div className="install-guide__step">
							<div className="install-guide__step-number">3</div>
							<div className="install-guide__step-icon">
								<CheckCircleOutlined />
							</div>
							<div className="install-guide__step-text">
								<p className="install-guide__step-title">Konfirmasi</p>
								<p className="install-guide__step-desc">
									Tekan <strong>&quot;Add&quot;</strong> di pojok kanan atas
								</p>
							</div>
						</div>
					</div>

					<div className="install-guide__note">
						<SafetyCertificateOutlined />
						<span>
							Pastikan menggunakan browser <strong>Safari</strong>. Browser lain
							di iOS tidak mendukung install.
						</span>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default InstallPWA;
